<template>
  <button
    :class="
      `bg-button bg-button--${this.variant} bg-button--text-color--${
        this.textColor
      } ${this.disabled && 'bg-button--disabled'} ${this.fullWidth &&
        'bg-button--full-width'}`
    "
    :type="type"
    @click="$emit('click')"
    :disabled="this.disabled"
  >
    <div
      :class="`bg-button__content ${this.isLoading && 'bg-button--is-loading'}`"
    >
      <div v-if="preIcon" class="bg-button__icon--pre-icon">
        <bg-icon :name="preIcon" />
      </div>
      <div v-if="text && text != ''">{{ text }}</div>
      <div v-if="postIcon" class="bg-button__post-icon">
        <bg-icon :name="postIcon" />
      </div>
    </div>
    <bg-loader type="circle" :dark="true" v-if="this.isLoading"></bg-loader>
  </button>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import BgLoader from "@/components/bg-loader";
import BgIcon from "@/components/bg-icon";

export default {
  name: "bg-button",
  components: {
    BgLoader,
    BgIcon,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: String,
    type: {
      default: "button",
      type: String,
      validator: function(value) {
        return ["reset", "submit", "button"].includes(value);
      },
    },
    variant: {
      default: "primary",
      type: String,
    },
    textColor: {
      type: String,
    },
    fullWidth: {
      default: false,
      type: Boolean,
    },
    postIcon: {
      type: String,
    },
    preIcon: {
      type: String,
    },
  },
};
</script>
